<header class="brand-bar">
    <span class="brand-label">Powered by</span>
    <img src="assets/images/Logo.svg" alt="PolicyStreet" class="brand-logo" />
</header>

<router-outlet></router-outlet>
